module.exports = __webpack_public_path__ + "static/media/undraw_dashboard_nklg.eae0400d.png";